import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Sarah', 'Michael', 'Emma', 'James', 'Sofia', 'Daniel', 'Isabella', 'David', 'Olivia', 'Carlos', 'Ana', 'Lucas', 'Maria', 'Alex', 'Laura', 'Ryan', 'Nicole', 'Marcus', 'Valentina', 'Jordan', 'Camila', 'Ethan', 'Rachel', 'Diego'];
const cities = ['Miami', 'New York', 'Los Angeles', 'Austin', 'Chicago', 'Denver', 'Seattle', 'Portland', 'San Diego', 'Nashville', 'Atlanta', 'Boston', 'Phoenix', 'Dallas', 'Toronto', 'London', 'Barcelona', 'Sydney', 'Vancouver', 'Berlin'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getTimeAgo(): string {
  const mins = Math.floor(Math.random() * 12) + 1;
  return `${mins} min ago`;
}
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: getRandomItem(names),
    city: getRandomItem(cities),
    timeAgo: getTimeAgo()
  });
  const cycle = useCallback(() => {
    // Show notification with new data
    setData({
      name: getRandomItem(names),
      city: getRandomItem(cities),
      timeAgo: getTimeAgo()
    });
    setVisible(true);
    // Hide after 3 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 3000);
    return hideTimer;
  }, []);
  useEffect(() => {
    // Initial delay before first notification
    const initialDelay = setTimeout(() => {
      const hideTimer = cycle();
      // Set up the loop: 3s visible + 5s hidden = 8s total
      const interval = setInterval(() => {
        cycle();
      }, 8000);
      return () => {
        clearTimeout(hideTimer);
        clearInterval(interval);
      };
    }, 4000);
    return () => clearTimeout(initialDelay);
  }, [cycle]);
  return <div className="md:hidden fixed bottom-6 left-4 right-4 z-50 pointer-events-none" data-id="element-173">
      <AnimatePresence data-id="element-174">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25,
        mass: 0.8
      }} className="mx-auto max-w-sm" data-id="element-175">
            <div className="flex items-center gap-3 px-4 py-3 rounded-2xl shadow-lg border border-white/20" style={{
          background: 'rgba(255, 255, 255, 0.85)',
          backdropFilter: 'blur(20px) saturate(180%)',
          WebkitBackdropFilter: 'blur(20px) saturate(180%)'
        }} data-id="element-176">
              {/* Product image */}
              <div className="flex-shrink-0" data-id="element-177">
                <img src="https://cdn.magicpatterns.com/uploads/e4Nn1zvqHur2UMBLWLy9yC/BZ-mockup.png" alt="Blue Zone Guide" className="w-11 h-11 rounded-lg object-cover" data-id="element-178" />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-179">
                <p className="text-[13px] leading-tight text-stone-800" data-id="element-180">
                  <span className="font-semibold" data-id="element-181">{data.name}</span> from{' '}
                  {data.city} just purchased
                </p>
                <p className="text-[13px] leading-tight text-stone-800 mt-0.5" data-id="element-182">
                  <span className="italic" data-id="element-183">Blue Zone Mindset Guide</span> for{' '}
                  <span className="font-bold" data-id="element-184">$6.39</span>
                </p>
                <p className="text-[11px] text-stone-400 mt-1" data-id="element-185">
                  {data.timeAgo}
                </p>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}